import apiService from "../../api/api.service";
import {
  CartResponse,
  CartCountResponse,
  MergeCartResponse,
  AddToCartRequest,
  AddToCartResponse,
  UpdateCartQuantityRequest,
  UpdateCartQuantityResponse,
  RemoveCartItemResponse,
  ClearCartResponse,
  ToggleCartItemResponse,
  ToggleSelectAllRequest,
  ToggleSelectAllResponse,
  SelectBySellerRequest,
  SelectBySellerResponse,
  ApplyDiscountRequest,
  ApplyDiscountResponse,
  RemoveDiscountResponse,
} from "./cart.types";

export const fetchCart = () => {
  return apiService.get<CartResponse>("/cart");
};

export const fetchCartCount = () => {
  return apiService.get<CartCountResponse>("/cart/count");
};

export const mergeCart = () => {
  return apiService.post<MergeCartResponse>("/cart/merge");
};

export const addToCart = (data: AddToCartRequest) => {
  return apiService.post<AddToCartResponse, AddToCartRequest>("/cart", data);
};

export const updateCartQuantity = (
  itemId: number,
  data: UpdateCartQuantityRequest,
) => {
  return apiService.put<UpdateCartQuantityResponse, UpdateCartQuantityRequest>(
    `/cart/${itemId}`,
    data,
  );
};

export const removeCartItem = (itemId: number) => {
  return apiService.delete<RemoveCartItemResponse>(`/cart/${itemId}`);
};

export const clearCart = () => {
  return apiService.delete<ClearCartResponse>("/cart");
};

export const toggleCartItem = (itemId: number) => {
  return apiService.patch<ToggleCartItemResponse>(
    `/cart/${itemId}/toggle`,
  );
};

export const toggleSelectAll = (data: ToggleSelectAllRequest) => {
  return apiService.patch<ToggleSelectAllResponse, ToggleSelectAllRequest>(
    "/cart/select-all",
    data,
  );
};

export const selectBySeller = (data: SelectBySellerRequest) => {
  return apiService.patch<SelectBySellerResponse, SelectBySellerRequest>(
    "/cart/select-by-seller",
    data,
  );
};

export const applyDiscount = (data: ApplyDiscountRequest) => {
  return apiService.post<ApplyDiscountResponse, ApplyDiscountRequest>(
    "/cart/apply-discount",
    data,
  );
};

export const removeDiscount = () => {
  return apiService.post<RemoveDiscountResponse>("/cart/remove-discount");
};